import useSWR from 'swr';

export interface AppConfig {
  waitingListMode: boolean;
}

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export function useAppConfig() {
  const { data, error, isLoading } = useSWR<AppConfig>('/api/waitlist/config', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 60000,
  });

  return {
    config: data,
    isLoading,
    error,
    waitingListMode: data?.waitingListMode ?? false,
  };
}
